var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.imageClass, _vm.imageState],style:(_vm.computedStyle),attrs:{"data-width":_vm.imageWidth,"data-height":_vm.imageHeight,"data-state":_vm.imageState}},[_vm._t("content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eaac184","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./core/vue/components/LazyBackground.vue
// module id = 457
// module chunks = 0 1 2 3 4 13 14 22